export default "__VITE_ASSET__FfVWBS20__"